import InputGroup from '../components/InputGroup';
import { useIsReadOnly, useMonthlyReportStore } from '../../../store/reportStore';

const LostCount = () => {
  const { reportMxData, setReportMxData } = useMonthlyReportStore();
  const isReadOnly = useIsReadOnly();

  return (
    <div className="row">
      <div className="panel">
        <div className="panel-heading">
          <h3>잃은양</h3>
        </div>
        <div className="panel-body">
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup
              title={'확인중'} //
              value={reportMxData?.lost_confirm}
              setReportMxData={setReportMxData}
              reportColumnName={'lost_confirm'}
              disabled={isReadOnly}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup
              title={'접촉중'} //
              value={reportMxData?.lost_contact}
              setReportMxData={setReportMxData}
              reportColumnName={'lost_contact'}
              disabled={isReadOnly}
            />
          </div>
          <div className="col-xs-6 col-sm-4 col-md-4">
            <InputGroup
              title={'회복중'} //
              value={reportMxData?.lost_recover}
              setReportMxData={setReportMxData}
              reportColumnName={'lost_recover'}
              disabled={isReadOnly}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LostCount;
